import * as React from "react";
import { forwardRef } from "react";
const SvgGridFilter = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.1263 15.3332V13.6873H11.8763V15.3332H8.1263ZM4.79297 10.8332V9.1665H15.2096V10.8332H4.79297ZM2.29297 6.31234V4.6665H17.7096V6.31234H2.29297Z", fill: "#646569" }));
const ForwardRef = forwardRef(SvgGridFilter);
export default ForwardRef;
